import { thunkEnsureLibraryColors } from '@store/migrationActions/thunkActions/thunkSymbolEdit'
import type { Action } from 'redux'
import { put } from 'redux-saga/effects'

/** After the library store changed: the palette gets the library colors the refs need. */
export function* ensureLibraryColors() {
  // A thunk goes through `put` like any action: the store runs redux-thunk.
  yield put(thunkEnsureLibraryColors() as unknown as Action)
}
